import React from "react";
import "./Component.css";
import Card from 'react-bootstrap/Card'

import logo from  "../components/Myntra_Footer.png";
import { Youtube, Instagram, Twitter, Linkedin, Facebook} from 'react-bootstrap-icons';


const Footer = (props) => {

    var infocards = [];

    infocards.push(
        <Card>
            <Card.Header className="card-header-cust card-header">
            </Card.Header>
            <Card.Body style={{textAlign: "left", fontSize:"14px"}} className="card-body">
                {/* <p className="api-link" onClick={() => props.updateModalStatesContactUs(true)}>Contact Us</p> */}
                {/* <img src={logo} alt="Myntra"/> */}
                <br></br>
                <a style={{color:"black"}} href="https://www.myntra.com/">SHOP</a>
                <br></br>
                <a style={{color:"black"}} href="https://careers.myntra.com/">CAREERS</a>
                <br></br>
                {/* <p style={{color:"black"}} onClick={() => props.updateModalStatesPP(true)}>Privacy Policy</p> */}
                <br></br>
                <div className="socials">
                <Linkedin onClick={event =>  window.location.href='https://in.linkedin.com/company/myntra'} size={25}/>
                <Youtube onClick={event =>  window.location.href='https://www.youtube.com/user/myntradotcom'} size={25}/>
                <Instagram onClick={event =>  window.location.href='https://www.instagram.com/myntra/?hl=en'} size={25}/>
                <Facebook onClick={event =>  window.location.href='https://www.facebook.com/myntra/'} size={25}/>
                <Twitter onClick={event =>  window.location.href='https://twitter.com/myntra'} size={25}/>
                </div>
                <hr></hr>
                <p style={{fontWeight:"lighter"}}>&copy; {(new Date().getFullYear())} www.myntra.com. 
                All rights reserved.</p>
  
            </Card.Body>
        </Card>
    )

    return(

            <div>
            {infocards}
            </div>
    );

};

export default Footer;